import { DatePipe } from "@angular/common";
import { FVPCriteriaValue, LoadClientToken } from "src/app/classes/entity";
import { FullValuePigService } from "src/app/services/full-value-pig.service";
import { HomeViewModel } from "./HomeViewModel";

export class ProfitFinderViewModel extends HomeViewModel {

  static profitFinderViewModel: ProfitFinderViewModel = null;

  private constructor() {
    super();
  }

  static getInstance(): ProfitFinderViewModel {
    if (this.profitFinderViewModel == null) {
      this.profitFinderViewModel = this.createInstance();
    }
    return this.profitFinderViewModel;
  }

  static createInstance(): ProfitFinderViewModel {
    this.profitFinderViewModel = new ProfitFinderViewModel();
    return this.profitFinderViewModel;
  }

  setData(loadClientToken: LoadClientToken, fullValuePigService: FullValuePigService, datePipe: DatePipe) {
    this.fullValuePigService = fullValuePigService;
    this.datePipe = datePipe;
    this.feature = loadClientToken.PFFeature;
    this.onLoadPaymentGrids = loadClientToken.GridMappingList;
    this.criteria = loadClientToken.PFCriteria;
    this.onLoadPerformanceParameters = loadClientToken.PerformanceList;
    this.companies = this.feature.AccountList;
    this.groupPaymentGrids();
    this.groupPerformanceParameter();
  }

  criteriaChanged(criteriaSelected: string) {
    this.valueSelectedItems = [];
    this.criteriaSelected = criteriaSelected;
    if (this.startDate != undefined && this.endDate != undefined) {
      this.getCriteriaValueByGroupDate();
      this.resetDataAfterCriteriaChanged();
    }
  }

  getCriteriaValueByGroupDate() {
    this.fullValuePigService.getCriteriaValueByGroupDate(this.getFVPCriteriaKey()).subscribe(
      response => {
        this.values = response;
      },
      errorResp => {
        this.fullValuePigService.throwError(errorResp);
      }
    );
  }

  onValueSelect(items: any) {
    this.fvpPackerMatrix = [];
    this.packer = [];
    this.getPFPacker();
  }

  onValueDeSelect(items: any) {
    this.fvpPackerMatrix = [];
    this.packer = [];
    if (this.valueSelectedItems.length > 0) {
      this.getPFPacker();
    }
  }

  onSelectAll(items: any) {
    this.fvpPackerMatrix = [];
    this.packer = [];
    this.valueSelectedItems = items;
    this.getPFPacker();
  }

  getPFPacker() {
    this.fullValuePigService.getPFPacker(this.getFVPCriteriaKey(), this.getValueSelected()).subscribe(
      response => {
        this.packer = [];
        this.fvpPackerMatrix = response;
        this.packerFilter();
      },
      errorResp => {
        this.fullValuePigService.throwError(errorResp);
      }
    );
  }

  packerFilter() {
    // this.fvpPackerMatrix.forEach(original => {
    //   if(original.MarketContract=="")
    //   this.packer.push(original)
    // });    
    let self = this;
    self.packer = [];
    self.fvpPackerMatrix.forEach((packerMatrix) => {
      self.paymentGrids.forEach((paymentGrid) => {
        if ((packerMatrix.Packer.Code == paymentGrid.packerCode) && (packerMatrix.MarketContract == paymentGrid.marketContract)) {
          if ((self.packer.findIndex(i => i.paymentGridID === paymentGrid.paymentGridID)) == -1) {
            self.packer.push(paymentGrid);
          }
        }
      });
    });
  }

  validateProfitFinderData() {
    return (this.startDate != undefined) && (this.endDate != undefined) && (this.companySelected != undefined) && (this.criteriaSelected != undefined) && (this.valueSelectedItems.length > 0) && (this.packerMatrixSelected != undefined) && (this.performanceParameterSelected != undefined);
  }

  getFVPCriteriaValue(): FVPCriteriaValue {
    this.criteriaValue = {
      PaymentGridIDs: this.paymentGridIDs,
      Values: this.getValueSelected(),
      MaxRecord: undefined
    };
    return this.criteriaValue;
  }

  resetDataAfterCriteriaChanged() {
    this.fvpPackerMatrix = [];
    this.packer = [];
    this.packerMatrixSelected = undefined;
    this.performanceParameterSelected = undefined;
  }

}
